import { useEffect, useState } from "react";
import { CalendarClock, Lock } from "lucide-react";
import { api } from "@/lib/api";

// Banner scadenza PER GIOCO. `game` = thebesttiket | surviva | scoreandlive |
// fantagiornata. Non mostra nulla se il gioco non ha stanze/tornei o se non
// c'è una deadline impostata. `compact` = versione mini per le card della Home.
export function DeadlineBanner({ game, compact = false }) {
  const [info, setInfo] = useState(null);
  const [skew, setSkew] = useState(0);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    let on = true;
    api("/deadlines/games")
      .then((d) => {
        if (!on) return;
        const g = d?.games?.[game];
        setInfo(g || null);
        if (d?.server_now) setSkew(new Date(d.server_now).getTime() - Date.now());
      })
      .catch(() => {});
    return () => { on = false; };
  }, [game]);

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!info || !info.has_content || !info.deadline_at) return null;

  const target = new Date(info.deadline_at).getTime();
  const diff = target - (now + skew);
  const passed = diff <= 0 || info.locked;

  let countdown = "";
  if (!passed) {
    const s = Math.floor(diff / 1000);
    const d = Math.floor(s / 86400);
    const h = Math.floor((s % 86400) / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;
    countdown = d > 0 ? `${d}g ${h}h ${m}m` : h > 0 ? `${h}h ${m}m ${sec}s` : `${m}m ${sec}s`;
  }

  const label = (info.name && info.name.trim())
    ? info.name.trim()
    : (info.matchday ? `Giornata ${info.matchday}` : "Prossima gara");
  const labelExtra = info.count > 1 ? ` +${info.count - 1}` : "";

  if (compact) {
    const shortDate = new Date(info.deadline_at).toLocaleString("it-IT", {
      day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
    });
    return (
      <div
        data-testid={`deadline-chip-${game}`}
        className={`mt-1.5 inline-flex items-center gap-1.5 text-xs font-bold rounded-md px-2 py-1 ${passed ? "bg-white/5 text-[#94A3B8]" : "bg-[#F59E0B]/15 text-[#F59E0B]"}`}
      >
        <CalendarClock size={12} />
        {passed ? `${label}${labelExtra} · scadenza chiusa` : `${label}${labelExtra} · ${shortDate} · ${countdown}`}
      </div>
    );
  }

  const fmtDate = new Date(info.deadline_at).toLocaleString("it-IT", {
    weekday: "long", day: "2-digit", month: "long", hour: "2-digit", minute: "2-digit",
  });
  return (
    <div
      data-testid={`deadline-banner-${game}`}
      className={`rounded-xl border p-3 flex items-center gap-3 ${passed ? "border-white/10 bg-[#181D22]" : "border-[#F59E0B]/50 bg-[#F59E0B]/10"}`}
    >
      <div className={`shrink-0 grid place-items-center h-11 w-11 rounded-lg ${passed ? "bg-white/5 text-[#94A3B8]" : "bg-[#F59E0B]/20 text-[#F59E0B]"}`}>
        {passed ? <Lock size={20} /> : <CalendarClock size={20} />}
      </div>
      <div className="min-w-0">
        <div className="text-[11px] uppercase tracking-widest text-[#94A3B8]">
          {passed ? "Scadenza chiusa" : "Prossima scadenza"}
        </div>
        <div className="font-extrabold leading-tight truncate">
          {label}{labelExtra} · <span className="text-[#F59E0B] capitalize">{fmtDate}</span>
        </div>
        <div className="text-xs text-[#94A3B8] mt-0.5" data-testid={`deadline-countdown-${game}`}>
          {passed ? "Iscrizioni e giocate chiuse" : <>Chiude tra <b className="text-white">{countdown}</b></>}
        </div>
      </div>
    </div>
  );
}
